import {Component, Input, TemplateRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import {NzFormModule} from "ng-zorro-antd/form";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzIconModule} from "ng-zorro-antd/icon";

@Component({
  selector: 'app-level2-otp-generator-choice-card',
  standalone: true,
  imports: [CommonModule, NzFormModule, NzButtonModule, NzIconModule],
  templateUrl: './level2-otp-generator-choice-card.component.html',
  styleUrls: ['./level2-otp-generator-choice-card.component.sass']
})
export class Level2OtpGeneratorChoiceCardComponent {
  @Input({required: true}) label: string | TemplateRef<any>;
  @Input({required: true}) icon: string;

  isString(value: string | TemplateRef<any>): boolean {
    return typeof value === 'string';
  }

  $TemplateRef = (template: TemplateRef<any>) => template;
}
